import React from "react";
import { TbWorldWww } from "react-icons/tb";

const ButtonSite = ({
  onClick,
  className = "",
  hoverLabel = "Visiter le site",
}) => {
  return (
    <button
      onClick={onClick}
      aria-label={hoverLabel}
      title={hoverLabel}
      className={`w-8 h-8 bg-orange-500 text-white rounded-md shadow-sm transition duration-300 ease-in-out hover:bg-orange-700 flex items-center justify-center ${className}`}
    >
      <TbWorldWww className="text-[12px]" />
    </button>
  );
};

export default ButtonSite;
